export default __webpack_public_path__ + "static/media/theo_v2.48f5e165.gif";